.perimeterx-modal {
  padding: 35px 25px;
}
